import { useCallback } from 'react';
import { useClient } from 'urql';
import { type DeliveryOrderDetail } from '@sg/graphql-schema';

import { type OrderingContext } from '@order/features/ordering';

import { type PartialLineItem } from '../../../../graphql';
import {
  BagCancelPreviousIntentDocument,
  type BagCancelPreviousIntentMutation,
} from '../../GraphQL/BagCancelPreviousIntent.generated';

export const useBagCancelPreviousIntent = () => {
  const client = useClient();

  const cancelPreviousIntent = useCallback(
    async (context: OrderingContext<PartialLineItem, DeliveryOrderDetail>) => {
      const paymentIntentId = context.paymentMethodOrIntentId;
      const mutation = client.mutation<BagCancelPreviousIntentMutation>;

      if (!paymentIntentId) throw new Error('Payment intent ID is required');

      const response = await mutation(BagCancelPreviousIntentDocument, {
        input: { paymentIntentId },
      }).toPromise();

      const maybeData = response.data?.cancelOrderPaymentIntent;

      return {
        paymentIntentId,
        success: Boolean(maybeData?.success),
      };
    },
    [client.mutation],
  );

  return { cancelPreviousIntent };
};
